import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { formatWaitLabel } from '../../../utility/isoDuration';

function Rate({ label, pct, raw, reached, bad }) {
  const [hover, setHover] = useState(false);
  return (
    <div className={`tl-rate${bad ? ' bad' : ''}`} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {hover ? <div className="p" style={{ fontSize: 10 }}>{`${raw} of ${reached} ${label}`}</div>
             : <><div className="p">{pct}%</div><div className="k">{label}</div></>}
    </div>
  );
}

export default function TouchpointNode({ card, metrics, showMetrics = true, branches = false, onEdit = () => {} }) {
  const { touchpoint: tp, isEntry } = card;
  const isNew = !!tp.__isNew; // unsaved live-preview card
  const waitLabel = formatWaitLabel(tp.wait_time);
  return (
    <div className="tl-tp">
      <div className="tl-tp-body">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h4>
            {branches && (
              <Tooltip title="This question's answer triggers a sub-journey">
                <span className="tl-branch-glyph" aria-label="triggers a sub-journey">⑂</span>
              </Tooltip>
            )}
            {isNew ? (tp.name || 'New touchpoint') : tp.name}
          </h4>
          <Tooltip title="Edit touchpoint"><EditOutlined aria-label="edit touchpoint" className="tl-tp-edit" onClick={() => onEdit(tp)} /></Tooltip>
        </div>
        <p className="tl-wait">⏱ {waitLabel ? `${waitLabel} ${isEntry ? 'after trigger' : 'later'}` : 'Sent immediately'}</p>
        <p className={`tl-msg${isNew && !tp.message ? ' placeholder' : ''}`}>
          {isNew ? (tp.message || 'Message preview…') : tp.message}
        </p>
        {showMetrics && !isNew && (
          <>
            <div className="tl-counts">
              <div className="tl-cbox reached"><div className="n">{metrics.reached}</div><div className="k">✓ reached</div></div>
              <div className="tl-cbox pending"><div className="n">{metrics.pending}</div><div className="k">⏳ pending</div></div>
            </div>
            <div className="tl-rates">
              <Rate label="clicked" pct={metrics.clickedPct} raw={metrics.clickedRaw} reached={metrics.reached} />
              <Rate label="replied" pct={metrics.repliedPct} raw={metrics.repliedRaw} reached={metrics.reached} />
              <Rate label="opt-out" pct={metrics.optOutPct} raw={metrics.optOutRaw} reached={metrics.reached} bad />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
